<div class="loading">
  <dx-load-indicator
    id="large-indicator"
    height="60"
    width="60"
  ></dx-load-indicator>
</div>
